var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlockUserDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "139px",
    height: "139px",
    viewBox: "0 0 139 139",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBlockUserDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.5%",
    y: "-3.5%",
    width: "107.1%",
    height: "107.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Skeliton-for-profile-not-found",
    transform: "translate(-379.000000, -237.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(262.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-pIC-Copy",
    transform: "translate(73.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "brooke-cagle-32432",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBlockUser.3a3e75fd",
    transform: "translate(46.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3778635,81.347238 C97.0269918,79.8377399 101.059724,79 105.3,79 C121.702857,79 135,91.5360271 135,107 C135,122.463973 121.702857,135 105.3,135 C97.2075772,135 89.8710808,131.948748 84.5143162,127 L6.58511266,127 C2.96397983,127 -5.1159077e-13,124.216679 -5.1159077e-13,120.804878 C-5.1159077e-13,91.7223716 25.1508848,68.1463414 56.1760735,68.1463414 C70.4439846,68.1463414 83.4695334,73.13246 93.3778635,81.347238 Z M87.3587278,84.6842797 C78.840288,78.2163191 67.9909184,74.3414634 56.1760735,74.3414634 C28.800907,74.3414634 6.60894981,95.1438429 6.60894981,120.804878 C6.60894981,120.800103 50.0776714,120.801651 79.4537295,120.803243 C77.0007241,116.729593 75.6,112.019012 75.6,107 C75.6,97.8908545 80.2139349,89.797668 87.3587302,84.6842814 Z M56.1760735,61.9512194 C37.9259625,61.9512194 23.1313244,48.0829667 23.1313244,30.9756098 C23.1313244,13.8682529 37.9259625,0 56.1760735,0 C74.4261844,0 89.2208225,13.8682529 89.2208225,30.9756098 C89.2208225,48.0829667 74.4261844,61.9512194 56.1760735,61.9512194 Z M56.1760735,55.7560976 C70.7761622,55.7560976 82.6118726,44.6614952 82.6118726,30.9756098 C82.6118726,17.2897242 70.7761622,6.19512195 56.1760735,6.19512195 C41.5759847,6.19512195 29.7402741,17.2897242 29.7402741,30.9756098 C29.7402741,44.6614952 41.5759847,55.7560976 56.1760735,55.7560976 Z M91.4658354,124.442086 C95.3221509,127.164967 100.111294,128.777778 105.3,128.777778 C118.057778,128.777778 128.4,119.027534 128.4,107 C128.4,102.108291 126.689268,97.5932737 123.801069,93.95769 L91.4658354,124.442086 Z M86.7989304,120.04231 L119.134165,89.5579143 C115.277849,86.8350331 110.488706,85.2222223 105.3,85.2222223 C92.5422224,85.2222223 82.1999999,94.9724657 82.1999999,107 C82.1999999,111.891709 83.9107315,116.406726 86.7989304,120.04231 Z",
    id: "icBlockUserDesktop"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockUserDesktop);
export default __webpack_public_path__ + "static/media/icBlockUserDesktop.f446a9a12544de66a7668b5d370319d9.svg";
export { ForwardRef as ReactComponent };